module.exports = __webpack_public_path__ + "img/pink_mannequin_2.cb9ab2eb.png";